import { NextParsedUrlQuery } from "next/dist/server/request-meta";
import { VariantGroup } from "@/types/types.ts";

export function createVariantGroupUrlObj(
  variantGroup: VariantGroup,
  query: NextParsedUrlQuery,
) {
  const queryParams = Object.entries(query).reduce((acc, [key, val]) => {
    return key === "path" || !val ? acc : { ...acc, [key]: val };
  }, {});

  return {
    pathname: variantGroup.pdpURL.path,
    query: { ...queryParams },
  };
}
